module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "modal"
    }
  }, [_c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "overflow-y": "scroll",
      "max-height": "250px"
    }
  }, [_vm._t("body")], 2), _vm._v(" "), (!_vm.cancelOnly) ? _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", function() {
    return [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.$emit('ok')
        }
      }
    }, [_vm._v("OK")]), _vm._v(" "), (_vm.withCancel) ? _c('button', {
      staticClass: "btn btn-success",
      on: {
        "click": function($event) {
          return _vm.$emit('cancel')
        }
      }
    }, [_vm._v("Cancel")]) : _vm._e()]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.cancelOnly) ? _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", function() {
    return [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.$emit('cancel')
        }
      }
    }, [_vm._v("Cancel")])]
  })], 2) : _vm._e()])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11e3b457","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plugins/Modal.vue
// module id = 1282
// module chunks = 0